export default "__VITE_ASSET__BnPNoZP___"